// src/components/km/ResourceCvButton.jsx
//
// Pulsante "CV" per ogni dettaglio candidato (Bug Log 06/10, suggerimento
// 3.1.2): apre il file reale del CV in una nuova scheda.
//
// Stesso endpoint già usato da "Gestione candidato > Modifica"
// (CandidateEditModal): GET /api/files/download?cvid=<cvid Altamira>, risposta
// blob. Nessuna modifica backend.
//
// Props:
//  - cvid       cvid Altamira (es. SidePanel di MultiFitting, dove candidate.cvid
//               è già quello giusto);
//  - resourceId candidato_id o cvid come in /resources/{id}: se manca `cvid`
//               il cvid Altamira si ricava da GET /resources/{id} (altamira_ref).
// Se il CV non esiste o il download fallisce, l'errore resta visibile accanto
// al pulsante, senza bloccare il resto del dettaglio.

import React, { useState } from 'react';
import axios from 'axios';
import { useRealKmClient } from '../../lib/useRealKmClient.js';

export default function ResourceCvButton({ cvid, resourceId, compact = false }) {
  const kmClient = useRealKmClient();
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState(null);

  async function apriCv() {
    setErrore(null);
    // Scheda aperta subito, nel gesto dell'utente: dopo un await il browser
    // bloccherebbe il popup.
    const tab = window.open('', '_blank');
    setLoading(true);
    try {
      let id = cvid;
      if (!id && resourceId) {
        const r = await kmClient.get(`/resources/${encodeURIComponent(resourceId)}`);
        id = r?.altamira_ref || null;
      }
      if (!id) throw new Error('CV non collegato a questa risorsa.');

      const resp = await axios.get(
        `/api/files/download?cvid=${encodeURIComponent(id)}&t=${Date.now()}`,
        { responseType: 'blob' },
      );
      const tipo = resp.headers?.['content-type'] || 'application/pdf';
      const url = window.URL.createObjectURL(new Blob([resp.data], { type: tipo }));
      if (tab) {
        tab.location.href = url;
      } else {
        // Popup bloccato: ripiego su download diretto.
        const a = document.createElement('a');
        a.href = url;
        a.download = `CV_${id}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch (e) {
      if (tab) tab.close();
      setErrore(e?.response?.status === 404 ? 'CV non disponibile.' : (e?.message || 'Errore nel recupero del CV.'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); apriCv(); }}
        disabled={loading || (!cvid && !resourceId)}
        title="Apri il CV in una nuova scheda"
        style={{
          padding: compact ? '3px 9px' : '5px 12px',
          fontSize: 12.5,
          fontWeight: 600,
          borderRadius: 8,
          border: '1px solid rgba(0,0,0,0.18)',
          background: '#FFFFFF',
          color: '#0C447C',
          cursor: loading ? 'wait' : 'pointer',
          opacity: (!cvid && !resourceId) ? 0.5 : 1,
          whiteSpace: 'nowrap',
        }}
      >
        {loading ? 'Apro…' : '📄 CV'}
      </button>
      {errore && <span style={{ fontSize: 11, color: '#A32D2D' }}>{errore}</span>}
    </span>
  );
}
